import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';
import ChartBatteryPacksByType from '../components/ChartBatteryPacksByType';
import CustomizedTreeView from '../components/CustomizedTreeView';
import BatteryDataGrid from '../components/BatteryDataGrid';
import HighlightedCard from '../components/HighlightedCard';
import PageViewsBarChart from '../components/PageViewsBarChart';
import SessionsChart from '../components/SessionsChart';
import StatCard from '../components/StatCard';

const data = [
  {
    title: 'Total Packs',
    value: '159',
    interval: 'Last 30 days',
    data: [
      151, 121, 157, 88, 25, 30, 90, 88, 95, 38, 145, 150, 48, 55, 60, 128, 65, 70, 68, 75, 80, 78, 85, 90, 88, 95, 100, 110, 120, 159
    ],
  },
  {
    title: 'Active Packs',
    value: '152',
    interval: 'Last 30 days',
    data: [169, 120, 157, 88, 25, 30, 90, 88, 95, 38, 145, 150, 48, 55, 60, 128, 65, 70, 68, 75, 80, 78, 85, 90, 88, 95, 100, 110, 120, 152],
  },
  {
    title: 'Inactive Packs',
    value: '0',
    interval: 'Last 30 days',
    data: Array(30).fill(0),
  },
];

export default function BatteryPacks() {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard card={card} />
          </Grid>
        ))}
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <HighlightedCard />
        </Grid>
      </Grid>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Battery Packs
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }}>
          <BatteryDataGrid />
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <ChartBatteryPacksByType />
          </Stack>
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
